<ngx-spinner type="ball-scale-ripple-multiple"></ngx-spinner>
<router-outlet></router-outlet>